export function isRelativeUrl(url: string): boolean {
    if (!url) {
        return true;
    }
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//')) {
        return false;
    }
    return true;
}

export function uncapitalize(str: string): string {
    if (!str) return str;
    if (str.charAt(0) === str.charAt(0).toUpperCase()) {
        return str.charAt(0).toLocaleLowerCase() + str.slice(1);
    }
    return str;
}

export function capitalize(str: string): string {
    if (!str) return str;
    return str[0].toUpperCase() + str.substring(1);
}

export function isNullOrWhiteSpace(str?: string | null): boolean {
    if (typeof str === 'undefined' || str === null) {
        return true;
    }
    return str.replace(/\s/g, '').length < 1;
}

export function isAlpha(ch: string): boolean {
    if (ch >= 'A' && ch <= 'Z') return true;
    if (ch >= 'a' && ch <= 'z') return true;
    if (ch >= 'А' && ch <= 'Я') return true;
    if (ch >= 'а' && ch <= 'я') return true;
    return false;
}

export function isEnglishAlpha(ch: string): boolean {
    return (ch >= 'A' && ch <= 'Z') || (ch >= 'a' && ch <= 'z');
}

export function isDigit(ch: string): boolean {
    return ch >= '0' && ch <= '9';
}

export function getNumberFromStr(str: string, defaultValue: number = 0): number {
    const number = Number.parseFloat(str.replace(',', '.'));
    return isNaN(number) ? defaultValue : number;
}

export function removeLineBreak(str: string): string {
    return str.replace(/(\r\n|\n|\r)/gm, '');
}

export function removeExtraWhiteSpaces(str: string): string {
    return str.replace(/\s+/g, ' ');
}
